/**
 * StatTile — the dashboard's unit of measure (W-003) and reused in user detail
 * (W-031) and the ingest monitor (W-023).
 */
import { Card, Skeleton, Statistic, Typography } from 'antd'
import type { ReactNode } from 'react'

export interface StatTileProps {
  label: string
  value: number | string
  /** Small caption under the value, e.g. a comparison with the previous period. */
  hint?: string
  suffix?: ReactNode
  prefix?: ReactNode
  loading?: boolean
  precision?: number
}

export const StatTile = ({
  label,
  value,
  hint,
  suffix,
  prefix,
  loading = false,
  precision,
}: StatTileProps) => (
  <Card size="small" className="admin-stat-tile">
    {loading ? (
      <Skeleton active paragraph={{ rows: 1 }} title={false} />
    ) : (
      <>
        <Statistic
          title={label}
          value={value}
          precision={precision}
          prefix={prefix}
          suffix={suffix}
        />
        {hint ? (
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {hint}
          </Typography.Text>
        ) : null}
      </>
    )}
  </Card>
)
